import React, { PureComponent } from "react";
import PropTypes from "prop-types";

export default class Accordion extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    isOpenOnLoad: PropTypes.bool,
    render: PropTypes.func.isRequired,
    content: PropTypes.any.isRequired,
  };

  static defaultProps = {
    isOpen: false,
    isOpenOnLoad: false,
  };

  state = {
    isOpen: this.props.isOpenOnLoad,
  };

  toggleExpandCollapse = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  render() {
    return (
      <>
        {this.props.render({
          isOpen: this.state.isOpen,
          isOpenOnLoad: this.props.isOpenOnLoad,
          content: this.props.content,
          toggleExpandCollapse: this.toggleExpandCollapse,
        })}
      </>
    );
  }
}
